module.exports = __webpack_public_path__ + "img/Mastif_w_biegu.725874ea.jpg";